import dynamic from 'next/dynamic';

export const ChangeLanguageBottomSheet = dynamic(
  () => import('./changeLanguageBottomSheetInternal').then((mod) => mod.default),
  {
    ssr: false,
  }
);
